import React from 'react';
import PropTypes from 'prop-types';

import { TeamIcon } from 'common/react/components/TeamIcon';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { TeamWatermarkBackground } from '../../../statspro/js/components/TeamWatermarkBackground';
import { getTranslation } from 'common/react/utils/translations';

export const MatchCardHeader = ({ voteData, matchData, modifier }) => {
    const roundLabel =
        voteData?.roundNumber === 0
            ? 'OR'
            : `${getTranslation('label.brownlow.tracker.round.abbrevation')}${
                  voteData?.roundNumber
              }`;

    return (
        <div
            className={`player-awards-match-card__header ${
                modifier ? `player-awards-match-card__header--${modifier}` : ''
            }`}
        >
            <TeamWatermarkBackground
                className="stats-card-featured-player__bg stats-card-featured-player__bg--no-border-radius"
                side="left"
                providerId={matchData.home.teamId}
            />
            <TeamWatermarkBackground
                className="stats-card-featured-player__bg stats-card-featured-player__bg--no-border-radius"
                side="right"
                providerId={matchData.away.teamId}
            />

            <div
                className={`player-awards-match-card__label ${
                    modifier
                        ? `player-awards-match-card__label--${modifier}`
                        : ''
                }`}
            >
                {modifier !== 'round-by-round' ? (
                    <>
                        <span className="player-awards-match-card__round-label">
                            {roundLabel}
                        </span>
                        {matchData.home.abbr.toUpperCase()}
                        <span className="player-awards-match-card__round-label-versus">
                            {getTranslation('label.brownlow.tracker.versus')}
                        </span>
                        {matchData.away.abbr.toUpperCase()}
                    </>
                ) : (
                    <>
                        {matchData.home.name}
                        <span className="player-awards-match-card__round-label-versus">
                            {getTranslation('label.brownlow.tracker.versus')}
                        </span>
                        {matchData.away.name}
                    </>
                )}
            </div>

            <TeamIcon
                className="icon player-awards-match-card__header-team-icon"
                theme="light"
                providerId={matchData.home.teamId}
            />
            <div className="player-awards-match-card__score-container">
                <span className="player-awards-match-card__score">
                    {matchData.home.totalScore}
                </span>
                <SvgIcon
                    icon="versus-white"
                    className="icon player-awards-match-card__versus"
                    folder="elements"
                    subfolder="stats"
                />
                <span className="player-awards-match-card__score player-awards-match-card__score--away">
                    {matchData.away.totalScore}
                </span>
            </div>
            <TeamIcon
                className="icon player-awards-match-card__header-team-icon"
                theme="light"
                providerId={matchData.away.teamId}
            />
        </div>
    );
};

MatchCardHeader.propTypes = {
    voteData: PropTypes.object,
    matchData: PropTypes.object.isRequired,
    modifier: PropTypes.string
};
